// =============================================================================
// QuickActions — atajos rápidos de la cabecera del dashboard
// v1.2: reemplaza el buscador primitivo por PatientQuickSearch (con dropdown
// de resultados y navegación directa a la ficha del paciente).
// =============================================================================

import { useNavigate } from 'react-router-dom';
import { PatientQuickSearch } from './PatientQuickSearch';

export function QuickActions() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-wrap items-center gap-2">
      <button
        type="button"
        onClick={() => navigate('/presupuestos/nuevo')}
        className="flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold bg-primary text-white shadow-primary hover:opacity-90 transition-opacity"
      >
        <span className="material-symbols-outlined text-lg">add</span>
        Nuevo presupuesto
      </button>

      <button
        type="button"
        onClick={() => navigate('/pacientes/nuevo')}
        className="flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold bg-white text-slate-700 border border-slate-200 hover:border-primary/30 hover:text-slate-900 transition-colors"
      >
        <span className="material-symbols-outlined text-lg">person_add</span>
        Nuevo paciente
      </button>

      <PatientQuickSearch />
    </div>
  );
}
